module.exports = __webpack_public_path__ + "static/media/travel.3d09b4bd.png";